<div class="hvac-product-attribute-group">
    <p class="hvac-product-data-attribute-type">{{ attributeGroupTitle }}</p>
    <p class="hvac-product-data-text" *ngFor="let value of attributes"><span>{{ value.type.name }}: </span>{{ value.value }}<span *ngIf="value.type.unitOfMeasure">{{ value.type.unitOfMeasure }}</span></p>
</div>
